import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Group, Modal, Stack, Text } from '@mantine/core';

interface EditPlanModalProps {
  confirmEditPlan: VoidFunction;
  hideModal: VoidFunction;
  opened: boolean;
}

const EditPlanModal = ({ confirmEditPlan, hideModal, opened }: EditPlanModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={hideModal} opened={opened} centered title={t('editSamplePlanTitle')}>
      <Stack>
        <Text>{t('editSamplePlanMsg')}</Text>
        <Group justify="flex-end">
          <Button onClick={hideModal} variant="outline">
            {t('no')}
          </Button>
          <Button onClick={confirmEditPlan}>{t('yes')}</Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default EditPlanModal;
